import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Image } from 'cloudinary-react';
const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    display: 'flex',
    maxWidth: '100%',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  img: {
    width: 2000,
    marginRight: -640,
    marginBottom: -450
  },
  '@media (max-width:836px)': {
    img: {
      marginRight: -690
    }
  }
}));

const HeaderImageMembers = () => {
  const classes = useStyles({});
  return (
    <div className={classes.root}>
      <Image className={classes.img} publicId="app_images/header-stairs-jump" />
    </div>
  );
};

export default HeaderImageMembers;
